import React, { useState } from 'react';
import Campaign from './campaign';
import CampaignMatrix from './campaignMatrix';

const tabs = ['Campaign', 'Campaign Performance matrics'];

const PromotionsAndMarketing = () => {
  const [activeTab, setActiveTab] = useState('Campaign');

  const renderContent = () => {
    switch (activeTab) {
      case 'Campaign':
        return <Campaign />;
      case 'Campaign Performance matrics':
        return <CampaignMatrix />;
      default:
        return null;
    }
  };

  return (
    <div className="pl-8 pr-6">
      <h2 className="text-2xl font-semibold mb-2 mt-1 ml-1">Promotions And Marketing</h2>

      <div className='bg-[var(--primary-bg-color)] rounded-lg shadow px-2 pt-5 dark:border dark:border-[var(--table-border)]'>
        {/* Tab Header */}
        <div className="flex border-b mb-2">
          {tabs.map((tab) => (
            <button
              key={tab}
              onClick={() => setActiveTab(tab)}
              className={`px-4 py-2 border-b-2 text-sm font-medium transition-all ${activeTab === tab
                  ? 'border-[#3587B8] text-[#3587B8]'
                  : 'border-transparent text-gray-500 hover:text-[#3587B8]'
                }`}
            >
              {tab}
            </button>
          ))}
          
        </div>
        <div>
          {renderContent()}
        </div>
      </div>
    </div>
  );
};

export default PromotionsAndMarketing;
